import { useCallback } from "react";

import { ICON_SIZE } from "@/config/constants";

import { PencilSimpleIcon, TrashSimpleIcon } from "@phosphor-icons/react";
import { FolderAction } from "../types";
import { FetchedFolder } from "@/services/api/fetchers/folders";

interface UseFolderActionsProps {
  editFolder: (folder: FetchedFolder) => void;
  deleteFolder: (folder: FetchedFolder) => void;
}

export function useFolderActions({ editFolder, deleteFolder }: UseFolderActionsProps) {
  const actions = useCallback(
    (folder: FetchedFolder) => {
      const actions: FolderAction[] = [
        { icon: <PencilSimpleIcon size={ICON_SIZE.md} />, key: "edit", label: "Edit", run: () => editFolder(folder) },
        {
          icon: <TrashSimpleIcon size={ICON_SIZE.md} />,
          key: "delete",
          label: "Delete",
          run: () => deleteFolder(folder),
        },
      ];

      return actions;
    },
    [deleteFolder, editFolder]
  );

  return actions;
}
